<template>
  <div id="social">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg6>
            <message-list></message-list>
          </v-flex>
          <v-flex lg6>
            <notification-list></notification-list>
          </v-flex>
          <v-flex lg6>
            <span><h4>{{'prayers._prayer_quote_'|translate}}</h4></span>
           <v-textarea outline v-model="prayer.text" :label="$t('jobs._Description_')">
           </v-textarea>
             <v-spacer></v-spacer>
            <v-btn @click="savePrayer" color="primary" required>{{'prayers._send_'|translate}}</v-btn>
          </v-flex>
          <v-flex lg6 align-content-end="true">
            <span><h4>{{'prayers._annoncement_quote_'|translate}}</h4></span>
           <v-textarea outline v-model="announcement.text" :label="$t('jobs._Description_')">
           </v-textarea>
             <v-spacer></v-spacer>
            <v-btn @click="saveAnnouncement" color="primary" required>{{'prayers._send_'|translate}}</v-btn>


            <!--  <v-btn @click="create_group_conversation" color="primary" required>create groups</v-btn> -->
          </v-flex>
        </v-layout>
      </v-container>
  </div>
</template>

<script>
import { db } from '@/api/firebaseInit';
import MessageList from '@/components/widgets/list/MessageList';
import NotificationList from '@/components/widgets/list/NotificationList';
import {churches} from '@/api/churches';
export default {
  components: {
    MessageList,
    NotificationList
  },
  data () {
    return {
      conversation_id: null,
      announcement: {
        text: '',
        timestamp: new Date()
      },
      prayer: {
        text: '',
        timestamp: new Date()
      },
    };
  },
  created () {
    this.$store.dispatch('fetchPrayers');
    this.$store.dispatch('fetchAnnouncements');
  },
  methods: {

    /*     create_group_conversation() {
          for (var i= 0; i< churches.length;i++) {
            console.log(churches[i])
         
      const convosRef = db.collection("conversations").doc();
      const refKey = convosRef.id;
      this.conversation_id = refKey;
      
      convosRef
        .set({
          created_date: new Date(),
          entityKey: this.conversation_id,
          id: this.conversation_id,
          image_url:"default",
          last_message:"",
          last_update:new Date(),
          participants:[],
          title:churches[i],
          type:"group"
        })
        .then(() => {
          console.log(this.conversation_id)
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
         }
    },
 */
    handleClick: (e) => {
      console.log(e);
    },
    savePrayer () {
      if (this.prayer.text === null || this.prayer.text === undefined) {
        alert(this.$t('prayers._prayer_error_'));
        return;
      }
      let today = (new Date());
      db.collection('prayers')
        .add({
          timestamp: today,
          text: this.prayer.text
        })
        .then(() => {
          alert(this.$t('prayers._prayer_saved_'));
          this.prayer.text = '';
        })
        .catch(error => {
          console.error('Error adding prayers: ', error);
        });
    },
    saveAnnouncement () {
      if (this.announcement.text === null || this.announcement.text === undefined) {
        alert(this.$t('prayers._ad_error_'));
        return;
      }
      let today = (new Date());
      db.collection('announcements')
        .add({
          timestamp: today,
          text: this.announcement.text
        })
        .then(() => {
          alert(this.$t('prayers._ad_saved_'));
          this.announcement.text = '';
        })
        .catch(error => {
          console.error('Error adding annoncement: ', error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/widgets/Prayers.vue